import React from 'react';
import { Repeat } from 'lucide-react';

const SubscriptionTabContent = () => {
  return (
    <div className="text-center py-12">
      <Repeat size={48} className="mx-auto text-gray-300 mb-4" />
      <h3 className="text-xl font-semibold text-gray-700 mb-2">Assinaturas</h3>
      <p className="text-gray-500">Em breve você poderá gerenciar suas assinaturas</p>
    </div>
  );
};

export default SubscriptionTabContent;